module.exports = __webpack_public_path__ + "static/media/smilingFaceWithHeartEyes.542b71c4.png";